module.exports = __webpack_public_path__ + "static/media/box-resources-01.ad63158c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/box-resources-01.png
// module id = 378
// module chunks = 0